var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tasting-notes-region" },
    _vm._l(_vm.notes, function (file, index) {
      return _c("HighlightButton", {
        key: index,
        attrs: {
          url: _vm.previousTastingNotesFiles[index],
          "url-new-window": true,
          title: _vm.title(file),
          "button-type": "rounded",
          "button-style": "outline",
          icon: "tail-arrow-down",
          block: "",
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }